import { ReactNode } from 'react';
import cx from 'classnames';

export interface ColorInputProps {
  /** `#rrggbb`. */
  value: string;
  onChange: (value: string) => void;
  /** Read by screen readers and shown as the tooltip. */
  label: string;
  /** What the person sees and clicks — a swatch, a brush button. */
  children: ReactNode;
  /** Layout, and the radius the focus ring follows. */
  className?: string;
}

/**
 * The browser's colour picker behind a surface of the caller's own. The native input lies over the whole
 * surface, transparent: it takes the click and the focus, and the picker opens next to the surface.
 */
export const ColorInput = ({ value, onChange, label, children, className }: ColorInputProps) => (
  <div
    className={cx(
      'relative inline-flex focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary',
      className,
    )}
  >
    {children}
    <input
      type="color"
      aria-label={label}
      title={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
    />
  </div>
);
